import 'ui-cropper/compile/minified/ui-cropper';
import 'ui-cropper/compile/minified/ui-cropper.css';
import { ImageCropService } from './image-crop.service';

export const imageCrop = angular
    .module('imageCrop', [
        'uiCropper'
    ])
    .service('ImageCropService', ImageCropService)
    .name;


// WEBPACK FOOTER //
// ./src/app/common/libs/image-crop/image-crop.module.js